import { isDefined } from "../shared/utils";
import { encrypto, dryeyeHidden, topographyHidden } from "../fileoprators/license";
/**
 * 本文件提供了各个模块通用的方法（methods)和属性（props）
 */
let notifyHandle;
export const Message = {
  data() {
    return {
      notifyHandle: undefined
    };
  },
  methods: {
    /**
     *  @params type = success/warning/info/error
     */
    notify(message, title = "", type = "info", duration = 5000) {
      if (isDefined(notifyHandle)) notifyHandle.close();
      notifyHandle = this.$notify({
        type: type,
        message: message,
        title: title,
        showClose: true,
        duration: duration
      });
    },
    message(message, type = "success", duration = 3000) {
      this.$message({
        type: type,
        message: message,
        duration: duration,
        showClose: true
      });
    },
    confirm(message, confirmText, cancelText, title, type = "info", Html = false) {
      return this.$confirm(message, title, {
        type: type,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        showCancelButton: !!cancelText,
        dangerouslyUseHTMLString: Html
      })
        .then(() => {
          return Promise.resolve();
        })
        .catch(() => {
          return Promise.reject(new Error());
        });
    }
  }
};
/**
 * 界面尺寸属性(props)
 */
export const License = {
  data() {
    return {
      license: {}
    };
  },
  created() {
    this.license = encrypto();
  },
  computed: {
    isTopographyEnabled() {
      return this.license.topography.enabled && !topographyHidden;
    },
    isDryEyeEnabled() {
      return this.license.dryeye.enabled && !dryeyeHidden;
    }
  }
};
export const Size = {
  props: {
    dispW: {
      type: Number,
      default: window.screen.width
    },
    dispH: {
      type: Number,
      // default: window.screen.height
      // default: 1080
      default: window.copyScreen ? 1080 : window.screen.height
    },
    headerHeight: {
      type: Number,
      default: 70
    }
  }
};
export const SubPageSize = {
  computed: {
    width() {
      return this.dispW;
    },
    height() {
      return this.dispH - 50;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/index.js